// assets/backend_api.js

console.log("backend_api.js v.1.2 loaded");

/** Python API @deprecated - and not used any more */
const AI_API_URL = "https://backend.skilltrack.fun/quiz_creation_file";

// API Base URLs
// const BASE_URL = "https://backend.skilltrack.fun/api";
const BASE_URL = window.SK_CONFIG?.BACKEND_BASE_URL;

if (!BASE_URL) {
  console.error("[backend_api] SK_CONFIG.BACKEND_BASE_URL is not defined.");
} else {
  console.log("[backend_api] BASE_URL is set to SK_CONFIG.BACKEND_BASE_URL:", BASE_URL);
}

window.SK = window.SK || {};
// put your fetch wrappers here
async function generateQuizText(payload) { /* ... */ }
async function generateQuizLink(payload) { /* ... */ }

const WEBSOCKET_EVENT_PROGRESS = "skilltrack:quizcreation:progress";
const WEBSOCKET_EVENT_CLOSE = "skilltrack:quizcreation:close";

SK.api = { generateQuizText, generateQuizLink };

// Set to true if email verification is required for the user to login after registration
SK.USER_VERIFICATION_REQUIRED = true; 

const HttpStatus = Object.freeze({
  OK:           "OK",
  CLIENT_ERROR: "CLIENT_ERROR",
  SERVER_ERROR: "SERVER_ERROR",
  ERROR:        "ERROR",
});

const checkHttpStatus = (status) => {
    console.log("[checkHttpStatus] status:", status);
    if (status >=200 && status < 300) {
        return HttpStatus.OK;
    } else if (status >= 400 && status < 500) {
        return HttpStatus.CLIENT_ERROR;
    } else if (status >= 500) {
        return HttpStatus.SERVER_ERROR;
    } else {
        return HttpStatus.ERROR;
    }
};


/************************
 * WebSocket integration
*************************/

console.log("[SkillTrack] WS module loaded");

// WebSocket instance
let skilltrackWS = null;

// The current job id
let currentJobId = null;

/**
 * Connect to SkillTrack backend websocket for a given jobId
 */
function connectSkilltrackWS(jobId) {
  currentJobId = jobId;

  // remove https and /api from BASE_URL to get WS URL:
  const WS_BASE_URL = BASE_URL.replace(/^https?:\/\//, '').replace(/\/api\/?$/, '');
  const WS_URL = `wss://${WS_BASE_URL}/ws?jobId=${jobId}`;
  console.log("[SkillTrack] Opening WS:", WS_URL);

  // Close previous socket if exists
  if (skilltrackWS) {
    try { skilltrackWS.close(); } catch (_) {}
  }

  skilltrackWS = new WebSocket(WS_URL);

  skilltrackWS.onopen = () => {
    console.log(`[SkillTrack] WS connected (job ${jobId})`);
  };

  skilltrackWS.onmessage = (ev) => {
    try {
      const data = JSON.parse(ev.data);

      // Dispatch global progress event
      document.dispatchEvent(
        new CustomEvent(WEBSOCKET_EVENT_PROGRESS, { detail: data })
      );

      console.log("[SkillTrack WS]", data);
    } catch (err) {
      console.error("[SkillTrack] WS parse error", err);
    }
  };

  skilltrackWS.onerror = (err) => {
    console.error("[SkillTrack] WS error:", err);
  };

  skilltrackWS.onclose = () => {
    console.warn("[SkillTrack] WS disconnected");
    document.dispatchEvent(
      new CustomEvent(WEBSOCKET_EVENT_CLOSE, { detail: { jobId: currentJobId } })
    );
    skilltrackWS = null;
  };
}

function closeSkilltrackWS() {
  if (skilltrackWS) {
    try {
      skilltrackWS.close();
      skilltrackWS = null;
      console.log("[SkillTrack] WS closed");
    } catch (err) {
      console.error("[SkillTrack] WS close error:", err);
    }
  }
}

/**
 * Request quiz regeneration
 * @param {QuizRegeneratePayload} payload
 */
async function requestQuizRegeneration(payload) {
  const url = `${BASE_URL}/quiz/regenerate`;
  console.log("[requestQuizRegeneration] requesting regeneration at url:", url);
  try {

    const token = getToken();
    const authHeaders = { Authorization: `Bearer ${token}` };
    const headers = {
        ...authHeaders,
        'Content-Type': 'application/json'
    };

    // === Backend Call with JWT ===
    const response = await fetch(url, {
        method: "POST",
        headers,
        body: JSON.stringify(payload)
    });

    const responseContentType = response.headers.get("content-type") || "";
    const body = responseContentType.includes("application/json") ? await response.json() : await response.text();

    if (checkHttpStatus(response.status) !== HttpStatus.OK) {
        console.log("[requestQuizRegeneration] checkHttpStatus: Error response from backend:", body);
        throw new Error(body.message || "errors.quizCreation");
    }
  } catch (err) {
    console.error("[requestQuizRegeneration] Error during fetch:", err);
    throw err;
  }
  
}
